import src from "IMAGE";
export default { src, width: 307, height: 337, blurWidth: 7, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAR0lEQVR42p2MSw6AIBTEuP9tCSgSPtWXESIumaSrNuN4VyvkC2IE74UbsrVHZjgPCEEsshQFKYkpe1dg9xYZU47gyyL/25c3YyTeEfXIOGUAAAAASUVORK5CYII="};
